import rmenu from "./src/rmenu";
rmenu.install = function(Vue) {
  Vue.component(rmenu.name, rmenu);
};
export default rmenu;
